import React from "react";

import i18n from "i18next";
import App from "onsite_app";
import ReactDOM from "react-dom";
import { initReactI18next } from "react-i18next";
import { BrowserRouter } from "react-router-dom-v5-compat";

import welcome from "../locales/en/welcome.json";
import "../styles/Welcome.css";
import Welcome from "../welcome";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug: true,
    resources: {
      en: { welcome },
    },
    lng: "en",
    fallbackLng: "en",
    defaultNS: "welcome",
    ns: "welcome",
  });

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    <BrowserRouter>
      <Welcome />
    </BrowserRouter>,
    document.body.appendChild(document.createElement("div")),
  );
});
